/**
 * Sprites drawn for the rooms, kept with the sentence that produced each.
 *
 * Separate from the gallery because the gallery is a deliberate three-by-three
 * of viewing angles and adding to it breaks both that grid and the test that
 * guards it. These are here for a different job: to furnish a room, which needs
 * a dozen things that agree with each other rather than nine that demonstrate a
 * range.
 *
 * Every one came out of the tool. That is the argument the page is making, so
 * nothing here may be hand-drawn.
 */

import type { SpriteSpec } from "../src/spec.js";
import type { Drawn } from "./bundled.js";

import props from "../specs/rooms/props.json";

export const PROPS: Drawn[] = (props as unknown[]).map((e) => e as Drawn);

export const PROP_SPECS: Record<string, SpriteSpec> = Object.fromEntries(PROPS.map((p) => [p.spec.name, p.spec]));
